import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    overflow: 'scroll',
    [theme.breakpoints.up('mobile')]: {
      overflow: 'unset',
    },
  },
  box: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    margin: [0, theme.spacing(4)],
    padding: [theme.spacing(4), 0, 0],
    position: 'relative',
    display: 'flex',
    flexFlow: 'column',
    flexDirection: 'column',
    [theme.breakpoints.up('mobile')]: {
      minWidth: 700,
      width: '100%',
      height: '100%',
      maxWidth: 1420,
      margin: [0, 'auto'],
      padding: [theme.spacing(7), 20, 0],
    },
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    [theme.breakpoints.up('mobile')]: {
      flexDirection: 'row',
      marginTop: theme.spacing(1),
    },
  },
  link: {
    marginTop: theme.spacing(2),
  },
}));



// WEBPACK FOOTER //
// ./src/components/ReferralRealEstateAgent/useStyles.js